export type UserGroupOption = {
  id: string;
  value: string;
  label: string;
  isPublic: boolean;
};

export enum UpdateUserPermissionsFormFields {
  UserGroups = 'userGroups',
}

export type UpdateUserFormModel = {
  [UpdateUserPermissionsFormFields.UserGroups]: UserGroupOption[];
};
